import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import s from './OfferDetails.module.scss';
function OfferDetails(
  {
  headlineFormatted = '',
  offer = null,
  shortDescriptionFormatted = '',
  toggleDetail = null,
}
) {

  const handleClick = useCallback(() => {
    if (toggleDetail) toggleDetail(offer);
  }, [offer, toggleDetail]);

  if (!offer) return null;

  return (
    <div
      aria-label="Open detail"
      data-testid="Open-detail"
      onClick={handleClick}
      onKeyDown={handleClick}
      role="presentation"
      className={s.descriptionContainer}
    >
      <p className={s.todayOffer}>{offer.title}</p>
      <p className={s.offerPercentage}>{headlineFormatted}</p>
      <p className={s.offerDescription}>{shortDescriptionFormatted}</p>
    </div>
  );
}

OfferDetails.propTypes = {
  headlineFormatted: PropTypes.string,
  offer: PropTypes.shape({
    title: PropTypes.string
  }),
  shortDescriptionFormatted: PropTypes.string,
  toggleDetail: PropTypes.func,
};

export default OfferDetails;
